import { reactive } from 'vue'
import { messages } from './messages'

const STORAGE_KEY = 'bags_locale'
export const LOCALES = ['en', 'zh']
export const DEFAULT_LOCALE = 'en'

export const localeState = reactive({
  locale: readStoredLocale()
})

function readStoredLocale() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored === 'zh' ? 'zh' : DEFAULT_LOCALE
  } catch {
    return DEFAULT_LOCALE
  }
}

export function getLocale() {
  return localeState.locale
}

export function setLocale(locale) {
  const next = locale === 'zh' ? 'zh' : DEFAULT_LOCALE
  localeState.locale = next
  try {
    localStorage.setItem(STORAGE_KEY, next)
  } catch {
    /* ignore */
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = next === 'zh' ? 'zh-CN' : 'en'
  }
}

function resolvePath(catalog, key) {
  if (!key) return undefined
  return key.split('.').reduce((node, part) => {
    if (node == null) return undefined
    return node[part]
  }, catalog)
}

export function t(key, locale = getLocale()) {
  const value = resolvePath(messages[locale], key)
  if (value != null) return value
  const fallback = resolvePath(messages[DEFAULT_LOCALE], key)
  return fallback != null ? fallback : key
}

export function tm(key, locale = getLocale()) {
  const value = resolvePath(messages[locale], key)
  if (value != null) return value
  return resolvePath(messages[DEFAULT_LOCALE], key)
}

export function localizedField(item, enKey = 'nameEn', zhKey = 'nameZh') {
  if (!item) return ''
  const en = item[enKey] || ''
  const zh = item[zhKey] || ''
  if (getLocale() === 'zh') {
    return zh || en
  }
  return en || zh
}

export function categoryName(cat) {
  return localizedField(cat, 'nameEn', 'nameZh')
}

export function productName(product) {
  if (!product) return ''
  if (product.nameEn != null || product.nameZh != null) {
    return localizedField(product, 'nameEn', 'nameZh')
  }
  return product.name || ''
}

export function productCategoryName(product) {
  if (!product) return ''
  if (product.categoryNameEn != null || product.categoryNameZh != null) {
    return localizedField(product, 'categoryNameEn', 'categoryNameZh')
  }
  return product.categoryName || ''
}

export function formValidationMessages(locale = getLocale()) {
  const errors = tm('form.errors', locale) || {}
  return {
    nameRequired: errors.name,
    emailRequired: errors.email,
    emailInvalid: errors.emailInvalid,
    websiteRequired: errors.website,
    messageRequired: errors.message
  }
}

export function i18nPlugin(app) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = getLocale() === 'zh' ? 'zh-CN' : 'en'
  }

  app.config.globalProperties.$t = t
  app.config.globalProperties.$tm = tm
  app.config.globalProperties.$locale = getLocale
  app.config.globalProperties.$setLocale = setLocale
  app.config.globalProperties.$categoryName = categoryName
  app.config.globalProperties.$productName = productName
  app.config.globalProperties.$productCategoryName = productCategoryName

  app.mixin({
    computed: {
      currentLocale() {
        return localeState.locale
      }
    }
  })
}
